export const PrototypesIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3777_4288)">
      <path d="M9.89996 3.23317L10.86 4.19317L8.93996 6.11317L9.88663 7.05984L11.8066 5.13984L12.7666 6.09984C12.9733 6.3065 13.3333 6.15984 13.3333 5.85984V2.99984C13.3333 2.81317 13.1866 2.6665 13 2.6665H10.14C9.83996 2.6665 9.69329 3.0265 9.89996 3.23317V3.23317ZM5.85996 2.6665H2.99996C2.81329 2.6665 2.66663 2.81317 2.66663 2.99984V5.85984C2.66663 6.15984 3.02663 6.3065 3.23329 6.09317L4.19329 5.13317L7.33329 8.2665V12.6665C7.33329 13.0332 7.63329 13.3332 7.99996 13.3332C8.36663 13.3332 8.66663 13.0332 8.66663 12.6665V7.99984C8.66663 7.8265 8.59329 7.65317 8.47329 7.5265L5.13996 4.1865L6.09996 3.2265C6.30663 3.0265 6.15996 2.6665 5.85996 2.6665V2.6665Z" />
    </g>
    <defs>
      <clipPath id="clip0_3777_4288">
        <rect width="16" height="16" />
      </clipPath>
    </defs>
  </svg>
);
